angular.module('NumbersEditor')
    .service('newAdhocService', ['NewAdhocGameFactory', '$q', function (newAdhocGameFactory, $q) {
        function newAdhocService(newAdhocGameFactory, $q) {
            var self = this;
            self._newAdhocGameFactory = newAdhocGameFactory;
            self._$q = $q;
        };

        newAdhocService.prototype.getNewAdhocGame = function () {
            var self = this;
            var deferred = self._$q.defer();
            self._newAdhocGameFactory.getNewAdhocGame()
                .success(function (newAdhoc) {
                    deferred.resolve(newAdhoc);
                })
                .error(function (error) {
                    deferred.reject(error);
                });

            return deferred.promise;
        }

        return new newAdhocService(newAdhocGameFactory, $q);
    }]);